/**
 * 영구 숨김 상태에서 우측 하단에 작은 토글 — 클릭하면 챗봇 다시 표시.
 *
 * 사용자가 챗봇을 영구 숨겼을 때(localStorage), 다시 켜기 위한 입구.
 * 사이드바를 안 건드리고 챗봇 모듈 내에서 완결시키기 위해 별도 컴포넌트.
 *
 * 디자인: 12x12 px 점. 호버 시 라벨 노출.
 */
import React from "react";
import { Box, Tooltip } from "@mui/material";
import { ds } from "../../styles/designSystem";
import { useChatbot } from "./ChatbotProvider";

export default function ChatbotShowToggle() {
    const { hidden, show } = useChatbot();
    if (!hidden) return null;

    return (
        <Tooltip title="AI 비서 다시 표시" placement="left">
            <Box
                onClick={show}
                role="button"
                aria-label="AI 비서 다시 표시"
                sx={{
                    position: "fixed",
                    right: 12, bottom: 12,
                    width: 14, height: 14,
                    borderRadius: "50%",
                    bgcolor: ds.colors.textMuted,
                    cursor: "pointer",
                    zIndex: 1300,
                    opacity: 0.5,
                    transition: "all 0.15s",
                    "&:hover": {
                        opacity: 1,
                        transform: "scale(1.6)",
                        bgcolor: ds.colors.primary,
                    },
                }}
            />
        </Tooltip>
    );
}
